"use client";

import { useEffect, useRef } from "react";
import axios from "axios";
import {AsyncCookie, getRedirectToString} from "@/components/shared/client/utils";
import {getModuleNameForAdmin} from "@/redux/apis/variables";
import {BASE_PATH_NAME} from "@/components/constants";
import {cleanPath} from "@/redux/apis/http";

export function useSessionHeartbeat(interval: number = 60000) {
    const lastActivityRef = useRef<number>(Date.now());
    const updateActivity = () => {
        lastActivityRef.current = Date.now();
    };

    useEffect(() => {
        const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];

        events.forEach(event =>
            window.addEventListener(event, updateActivity)
        );

        const pingInterval = setInterval(() => {
            const now = Date.now();
            const diff = now - lastActivityRef.current;
            const cookieName = `${process.env.NEXT_PUBLIC_COOKIE_PREFIX}_SESSION_ID`;
            const value = AsyncCookie.getCookie(cookieName);
            if(value) {
                const url = `${process.env.NEXT_PUBLIC_SERVER_DOMAIN}webapi/shared/keepTheSessionAlive`;
                if (diff < interval) {
                    axios.post(url, {
                        timeZoneDifference: new Date().getTimezoneOffset(),
                        licenseKey: process.env.NEXT_PUBLIC_LICENSE_KEY,
                        requestURL: cleanPath(getModuleNameForAdmin()[0], BASE_PATH_NAME),
                        pathname: cleanPath(getModuleNameForAdmin()[0], BASE_PATH_NAME),
                        fetchType: "lazy",
                        siteCookiePrefix: process.env.NEXT_PUBLIC_COOKIE_PREFIX,
                        redirectTo: getRedirectToString(window.location.href),
                        sessionId: AsyncCookie.getCookie(`${process.env.NEXT_PUBLIC_COOKIE_PREFIX}_SESSION_ID`),
                        hostname: window.location.origin,
                        customQueryFile: "userDashboard"
                    }).then((res: any) => {
                        if(res?.data?.data?.signout) {
                            AsyncCookie.deleteCookie(cookieName)
                        }
                    })
                }
            }
        }, interval);

        return () => {
            events.forEach(event =>
                window.removeEventListener(event, updateActivity)
            );
            clearInterval(pingInterval);
        };
    }, [interval]);
}
